import { profileFacts, profileTags } from '@/mocks/homeData';

export default function ProfileSection() {
  return (
    <section id="profile" className="w-full border-y border-background-200 bg-secondary-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[360px_1fr] lg:items-start">
          <div className="rounded-lg border border-background-200 bg-background-50 p-5">
            <div className="flex items-center gap-4">
              <div className="h-20 w-20 shrink-0 overflow-hidden rounded-full border-2 border-accent-400">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylized%20painterly%20portrait%20of%20an%20elegant%20woman%20with%20flowing%20hair%20rendered%20in%20warm%20coral%20and%20amber%20tones%2C%20no%20recognizable%20facial%20detail%2C%20soft%20gradient%20cream%20background%2C%20editorial%20magazine%20illustration%20style&width=400&height=400&seq=fengjian-avatar-2026&orientation=squarish"
                  alt="风间由美资料头像插画"
                  title="风间由美个人资料头像"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div>
                <h3 className="font-heading text-lg font-bold text-foreground-950">风间由美</h3>
                <p className="mt-1 text-xs text-foreground-500">公开资料整理 · 持续补充</p>
                <span className="mt-2 inline-flex items-center gap-1 rounded-full bg-primary-100 px-2.5 py-0.5 text-xs font-medium text-primary-700">
                  <i className="ri-record-circle-line animate-softPulse" aria-hidden="true" />
                  追踪中
                </span>
              </div>
            </div>

            <div className="mt-4 flex flex-wrap gap-2">
              {profileTags.map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-secondary-200 bg-secondary-100 px-2.5 py-1 text-xs text-secondary-900"
                >
                  {tag}
                </span>
              ))}
            </div>

            <a
              href="#collections"
              className="mt-5 flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-bookmark-3-line" aria-hidden="true" />
              查看完整合集索引
            </a>
          </div>

          <div>
            <span className="font-label text-xs tracking-[0.3em] text-primary-600">PROFILE</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              个人资料速览
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              把公开渠道能找到的基础信息汇总成一张表，免去到处搜索的麻烦。资料会随新动态持续补充。
            </p>

            <dl className="mt-6 grid grid-cols-1 gap-x-8 gap-y-0 sm:grid-cols-2">
              {profileFacts.map((fact) => (
                <div
                  key={fact.label}
                  className="flex items-center justify-between gap-4 border-b border-background-200 py-3.5"
                >
                  <dt className="text-sm text-foreground-500">{fact.label}</dt>
                  <dd className="text-right text-sm font-medium text-foreground-900">{fact.value}</dd>
                </div>
              ))}
            </dl>

            <div className="mt-6 flex items-start gap-3 rounded-lg border border-accent-200 bg-accent-50 p-4">
              <i className="ri-information-line mt-0.5 text-accent-700" aria-hidden="true" />
              <p className="text-xs leading-relaxed text-foreground-700">
                以上内容由网友根据公开讨论整理，仅供浏览参考，不代表事实认定。如与最新情况有出入，欢迎在社区指正补充。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}